/**
 * Method to transform the country array into an object.
 * Example:
 *  array = [{code: 'AF', name: 'Afghanistan'}, {code: 'AX', name: 'Åland Islands' }]
 *
 *  resultObject = { AF: 'Afghanistan', AX: 'Åland Islands' }
 *
 * @param {Array} array
 */
export function fromArrayToObject(array: { code: string; name: string }[]) {
  let newObject = {};

  array.forEach((country) => {
    newObject = {
      ...newObject,
      [country.code]: country.name,
    };
  });

  return newObject;
}

export function getDefaultCountryFromBrowser(): string {
  let userCountry = Intl.DateTimeFormat().resolvedOptions().locale.toUpperCase();
  if (userCountry.indexOf("-") !== -1) {
    userCountry = userCountry.split("-")[1];
  }
  return userCountry;
}
